import { ObjectFieldsChecker } from "../../../../../../tools/ObjectFieldsChecker";
import { FixResultDto } from "../../../../../networking/data/responses/upgrade/FixResultDto";

export class FixResult {
    public readonly landlordRewardInTokens?: string;
    public readonly currentGuestRewardInTokens: string;
    public readonly totalRewardInTokens: string;
    public readonly initialRewardInTokens?: string;
    public readonly piggyMultiplier?: number;
    public readonly piggyClubMultiplier?: number;

    public constructor(dto: FixResultDto) {
        this.validateDto(dto);
        this.landlordRewardInTokens = dto.landlordRewardInTokens;
        this.currentGuestRewardInTokens = dto.currentGuestRewardInTokens;
        this.totalRewardInTokens = dto.totalRewardInTokens;
        this.initialRewardInTokens = dto.initialRewardInTokens ?? "0";
        this.piggyMultiplier = dto.piggyMultiplier ?? 0;
        this.piggyClubMultiplier = dto.piggyClubMultiplier ?? 0;
    }

    private validateDto(dto: FixResultDto): void {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "currentGuestRewardInTokens",
            "totalRewardInTokens"
        ]);
    }
}
